'use client'

import React from "react";
import classNames from "classnames";

import MapSide from "./MapSide";
import TableSide from "./TableSide";

import CurrentlyViewing from "./CurrentlyViewing";
import { MapHeader } from "./MapHeader";
import { CloseIcon } from "@/migrated-widgets/table-map/components/icons/CloseIcon";

import { AudienceVisitorsTableMapProvider, useAudienceVisitorsTableMapState } from "./AudienceVisitorsTableMapState";
import { GlobalProvider } from "@/migrated-widgets/table-map/contexts/GlobalState";
import useExportAudienceMap from "./hooks/useExportAudienceMap";


const AudienceVisitorsTableMapOrganism = () => {
    useExportAudienceMap();
    const { setAudiencesIds, setZipCodes, zipCodes, setGroupIds, setMakeIds, setModelIds, setVehicleTypes, setResetZoom, setProducts, currentlyViewing } = useAudienceVisitorsTableMapState();
    const resetFilters = () => {
        setAudiencesIds([]);
        setZipCodes([]);
        setGroupIds([]);
        setMakeIds([]);
        setModelIds([]);
        setVehicleTypes([]);
        setResetZoom(true);
        setProducts([]);
    }


    return (
        <section className="bg-white relative w-full overflow-hidden">
            <MapHeader />
            <div className="grid items-stretch" style={{ gridTemplateColumns: "316px auto", height: '529px' }}>
                <div className={classNames('relative', 'flex-col', 'overflow-hidden', 'overflow-y-auto', 'visible-scrollbar')}>
                    {zipCodes.length > 0 &&
                        <div className={classNames('flex', 'bg-table-map-gray', 'justify-between', 'px-10', 'w-full', 'items-center', 'py-3', 'sticky', 'top-0', 'z-10')}>
                            <p className={classNames('font-bold', 'text-sm', 'text-white')}>Zip Code: {zipCodes[0]}</p>
                            <CloseIcon className="cursor-pointer" onClick={() => { setZipCodes([]); setResetZoom(true); }} />
                        </div>
                    }
                    {currentlyViewing && <CurrentlyViewing onClick={resetFilters} viewing={currentlyViewing} />}
                    <TableSide />
                </div>
                <div className={classNames('flex', 'flex-col', 'relative')}>
                    <MapSide />
                </div>
            </div>
        </section>
    )
}

export default React.memo(function AudienceVisitorsOrganismWrapper() {
    return (
        <GlobalProvider>
            <AudienceVisitorsTableMapProvider>
                <AudienceVisitorsTableMapOrganism />
            </AudienceVisitorsTableMapProvider>
        </GlobalProvider>
    )
});